import { makeStyles } from '@mui/styles';

export const sectionStyle = makeStyles(() => ({
    circleAndTitleWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '16px',
    },
}));
